import React from "react";
import { SiteLink as Link, SiteNavLink as NavLink } from "./site-link";
import { HiMenuAlt3, HiX } from "react-icons/hi";
import { navLinks } from "../../constants/landing";

const linkClass = ({ isActive }) =>
  `text-[15px] font-medium transition-colors ${
    isActive ? "text-primary-dark" : "text-[#5b5f73] hover:text-primary-dark"
  }`;

export default function LandingHeader() {
  const [open, setOpen] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all ${
        scrolled ? "bg-white/95 shadow-sm backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] w-[92%] max-w-[1200px] items-center justify-between">
        <Link to="/" onClick={() => setOpen(false)}>
          <img src="/assets/images/logo2.png" alt="PrepaidMeter.ng" className="h-9 w-auto lg:h-10" />
        </Link>

        <nav className="hidden items-center gap-9 lg:flex">
          {navLinks.map((l) => (
            <NavLink key={l.to} to={l.to} end className={linkClass}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <Link
            to="/buy-meter"
            className="rounded-full bg-primary-dark px-5 py-2.5 text-[15px] font-semibold text-white transition hover:bg-primary-light"
          >
            Get a meter
          </Link>
        </div>

        <button
          type="button"
          aria-label={open ? "Close menu" : "Open menu"}
          className="lg:hidden"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <HiX className="text-[28px]" /> : <HiMenuAlt3 className="text-[28px]" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-black/5 bg-white lg:hidden">
          <div className="mx-auto flex w-[92%] flex-col gap-1 py-4">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-xl px-3 py-3 text-base font-medium ${
                    isActive ? "bg-primary-dark/5 text-primary-dark" : "text-[#5b5f73]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/buy-meter"
              onClick={() => setOpen(false)}
              className="mt-3 rounded-full bg-primary-dark px-5 py-3 text-center font-semibold text-white"
            >
              Get a meter
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
